var _defs, _path, _rect, _rect2, _line, _line2, _line3, _path2, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoboLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.5,5.5H7.5a2,2,0,0,0-2,2v33a2,2,0,0,0,2,2h33a2,2,0,0,0,2-2V7.5A2,2,0,0,0,40.5,5.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 33.0649,
    y: 20.3413,
    width: 5.4351,
    height: 7.2015,
    rx: 2.7175
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 16.9216,
    y: 20.3413,
    width: 5.4351,
    height: 7.2015,
    rx: 2.7175
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.5,
    y1: 16.6727,
    x2: 9.5,
    y2: 27.5428
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.5011,
    y1: 25.2337,
    x2: 14.4214,
    y2: 20.3375
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.067,
    y1: 23.6754,
    x2: 14.9351,
    y2: 27.5265
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.95,23.0589a2.7176,2.7176,0,0,1,2.7175-2.7176h0a2.7176,2.7176,0,0,1,2.7176,2.7176v1.7664a2.7176,2.7176,0,0,1-2.7176,2.7175h0A2.7175,2.7175,0,0,1,24.95,24.8253"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 24.9504,
    y1: 27.5428,
    x2: 24.9504,
    y2: 16.6727
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoboLogo);
export default __webpack_public_path__ + "static/media/kobo_logo.47ec5a4991aa4f47f0f4ee666ecb6f9c.svg";
export { ForwardRef as ReactComponent };